import React, { useState, useEffect } from 'react';
import { Skeleton } from 'antd';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';
import config from '../../settings/config.json';

const Video = function() {
    const [settings, setSettings] = useState(null);
    const [videos, setVideos] = useState([]);

    useEffect(() => {
      const fetchSettings = async () => {
        try {
          const response = await axios.get(`/api/settings`);
          setSettings(response.data[0]);
        } catch (error) {
          console.error('ERROR:', error);
        }
      };

      fetchSettings();
      
      const interval = setInterval(fetchSettings, 5000);
      return () => clearInterval(interval);
    }, []);
    
    useEffect(() => {
      const fetchVideos = async () => {
        try {
          const response = await axios.get(`/api/video`);
          setVideos(response.data);
        } catch (error) {
          console.error('ERROR:', error);
        }
      };

      fetchVideos();

      const interval = setInterval(fetchVideos, 3000);
      return () => clearInterval(interval);
    }, []);

    return (
        <div className='Video'>
            <br/><br/><br/><br/>
            <Container className="my-5">
                <Row className="justify-content-center">
                    <div>
                        <center>
                            <h1>
                                <i className="fa-solid fa-microphone text-gradient"></i> 
                                {settings?.client?.videoPage?.title ? settings.client.videoPage.title : ''}
                            </h1>
                            <h3 className='font-reqular text-secondary'>
                                {settings?.client?.videoPage?.description ? settings.client.videoPage.description : <Skeleton active />}
                            </h3>
                        </center>
                        <br/><br/>
                    </div>
                        {videos.length > 0 ? (
                            videos.map(video => (
                        <Col md={4} className="mb-4">
                        <center>
                            <h5 className='text-secondary'>
                                {video?.title ? video?.title : <Skeleton.Button active />}
                            </h5>
                        </center>
                                <div className="video-wrapper" key={video._id}>
                                    {video.video && (
                                        <video className="video-responsive" controls>
                                            <source src={`/api${video.video}`} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    )}
                                </div>
                                </Col>
                            ))
                        ) : (
                            <center className='mt-5'>
                                <h2 className='text-gradient'>Oops...</h2>
                                <h4 className='mt-3 text-secondary font-reqular'>Video yoxdur</h4>
                                <br /><br /><br />
                            </center>
                        )}
                </Row>
            </Container>
            <center><div className='red-divider'></div></center>
            <br/><br/><br/>
        </div>
    );
};

export default Video;
